<template>
  <header class="header sticky-header fixed-header is-sticky">
    <div class="container">
      <div class="header-inner d-none d-lg-flex">
        <div class="header-logo">
          <router-link :to="menuPrefix+'/'" ><img src="https://nkcreative.hu/frontend/images/logo_light.png" height="50" alt="NK Creative logo" title="NK Creative logo">
          </router-link>
        </div>
        <div class="header-navigation">
          <router-link v-if="language==='hu'" to="/" class="mr-2 p-3" @click="changeLanguage('en')"><img  @click="changeLanguage('en')" src="https://nkcreative.hu/frontend/images/en.svg" height="30" alt="NK Creative english" title="NK Creative english"></router-link>
          <router-link v-if="language==='en'" to="/en" class="mr-2 p-3" @click="changeLanguage('hu')"><img @click="changeLanguage('hu')" src="https://nkcreative.hu/frontend/images/hu.svg" height="30" alt="NK Creative magyar" title="NK Creative magyar"></router-link>
          <button aria-label="menu" type="button"  class="header-navigation-trigger " v-bind:class="{'is-active':headerNavigationTrigger}" @click="headerNavigationTrigger=!headerNavigationTrigger">
            <span></span>
            <span></span>
            <span></span>
          </button>
          <nav class="main-navigation " v-bind:class="{'is-visible':headerNavigationTrigger}">
            <ul class="section-name">
              <li  class=""><router-link :to="{name:'Home',hashtag:'#home'}">{{$t('Címlap')}}</router-link></li>
              <li ><router-link :to="menuPrefix+'/portfolio'">{{$t('Portfólió')}}</router-link></li>
              <li ><router-link :to="menuPrefix+'/#about'">{{$t('Rólunk')}}</router-link></li>
              <li class="active"><router-link :to="menuPrefix+'/#last-work'">{{$t('Legutóbbi munkáink')}}</router-link></li>
              <li  class=""><router-link :to="menuPrefix+'/galeria'">{{$t('Galériák')}}</router-link></li>
              <li  class=""><router-link :to="menuPrefix+'#contact'" >{{$t('Kapcsolat')}}</router-link></li>
            </ul>
          </nav>
        </div>
      </div>
      <div class="header-inner mobil-header-inner d-block d-lg-none">
        <div class="header-navigation">
          <div class="header-logo d-inline-block">
            <router-link :to="'/'" ><img src="https://nkcreative.hu/frontend/images/logo_light.png" height="30"  alt="NK Creative logo" title="NK Creative logo">
            </router-link>
          </div>
            <button aria-label="menu" type="button" @click="headerNavigationTrigger=!headerNavigationTrigger" class="pl-3 ml-3 header-navigation-trigger d-inline-block float-right " v-bind:class="{'is-active':headerNavigationTrigger}">
            <span></span>
            <span></span>
            <span></span>
          </button>
          <router-link v-if="language==='hu'" to="/" class="mr-2 pr-3 pull-right" @click="changeLanguage('en')"><img  @click="changeLanguage('en')" src="https://nkcreative.hu/frontend/images/en.svg" height="30" alt="NK Creative english" title="NK Creative english"></router-link>
          <router-link v-if="language==='en'" to="/en" class="mr-2 pr-3 pull-right" @click="changeLanguage('hu')"><img @click="changeLanguage('hu')" src="https://nkcreative.hu/frontend/images/hu.svg" height="30" alt="NK Creative magyar" title="NK Creative magyar"></router-link>

        </div>
        <nav id="mobil-menu" class="main-navigation " v-bind:class="{'is-visible':headerNavigationTrigger}">
          <ul class="section-name">
            <li data-menuanchor="home" @click="headerNavigationTrigger=!headerNavigationTrigger" class="w-100"><router-link :to="{name:'Home',hashtag:'#home'}" >{{$t('Címlap')}}</router-link></li>
            <li data-menuanchor="about" @click="headerNavigationTrigger=!headerNavigationTrigger" class="w-100"><router-link  :to="menuPrefix+'/portfolio'">{{$t('Portfólió')}}</router-link></li>
            <li data-menuanchor="portfolio" @click="headerNavigationTrigger=!headerNavigationTrigger" class="w-100"><router-link  :to="menuPrefix+'/#about'">{{$t('Rólunk')}}</router-link></li>
            <li data-menuanchor="third-section" @click="headerNavigationTrigger=!headerNavigationTrigger" class="w-100"><router-link  :to="menuPrefix+'/#last-work'">{{$t('Legutóbbi munkáink')}}</router-link></li>
            <li data-menuanchor="fourth-section" @click="headerNavigationTrigger=!headerNavigationTrigger" class="w-100"><router-link  :to="menuPrefix+'/#work'">{{$t('Hogyan dolgozunk?')}}</router-link></li>
            <li  class="w-100" @click="headerNavigationTrigger=!headerNavigationTrigger"><router-link :to="menuPrefix+'/galeria'">{{$t('Galériák')}}</router-link></li>
            <li data-menuanchor="contact" class="w-100" @click="headerNavigationTrigger=!headerNavigationTrigger"><router-link  :to="menuPrefix+'#contact'" >{{$t('Kapcsolat')}}</router-link></li>
          </ul>
        </nav>
      </div>
      </div>
  </header>
</template>

<script>

export default {
  name: 'Menu',
  data () {
    return {
      headerNavigationTrigger: false,
      mobilMenu: false
    }
  },
  computed: {
    language: function () {
      return this.$translate.locale
    },
    menuPrefix: function () {
      return this.$translate.locale === 'en' ? '/en' : ''
    }
  },
  methods: {
    changeLanguage (lang) {
      this.$translate.locale = lang
      localStorage.setItem('language', lang)
      this.$eventHub.$emit(
        'language-changed', lang

      )
    }
  },
  mounted () {
    setTimeout(function () {
      window.addEventListener('scroll', (e) => {
        let scrollPos = window.scrollY
        if (scrollPos > 200) {
          document.querySelector('.sticky-header').classList.add('is-sticky')
        } else {
          document.querySelector('.sticky-header').classList.remove('is-sticky')
        }
      })
    }, 500)
  }
}
</script>

<style scoped>
 .pull-right{
   float:right;
   margin-right:10px;
 }
</style>



// WEBPACK FOOTER //
// src/components/Menu.vue